import React, { Dispatch, SetStateAction, useMemo } from "react";

import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import { Box, Button, Container, Divider, Stack, Typography } from "@mui/material";
import { omit, values } from "lodash";
import { IRole, IShare } from "store/types";

import { AccessForm } from "../Access-three/AccessForm";
import { useShareContext } from "../context/share-context";
import { IShareState } from "../context/use-share-context-hook";
import { ShareItem } from "../Share-item/ShareItem";

import "./ShareList.styles.scss";

export interface ShareListProps {
  roles: IRole[];
  users: IShare[];
  goToShare: () => void;
  onResend: (id: number) => Promise<void>;
  accessState: IShareState;
  setAccessState: Dispatch<SetStateAction<IShareState>>;
  patchShares: () => Promise<void>;
}

export interface ISelectedSharedData {
  components: IShareState;
  userData: {
    roleId: number;
    id: number;
    type: "invite" | "share";
  };
}

export const ShareList: React.FC = () => {
  const {
    shareBackHandler,
    resendInvite: onResend,
    patchShares,
    roles,
    setStepKey,
    stepKey,
    state,
    globalDoc
  } = useShareContext();

  const inviteArray = useMemo(() => values(omit(state, "share")), [state]);

  return (
    <Container disableGutters sx={{ display: "flex", flexDirection: "column", gap: "14px" }} className="share-list">
      <Container
        className="share-list"
        sx={{ display: "flex", gap: "20px", paddingTop: "14px", maxHeight: "500px", minHeight: "300px" }}
        disableGutters
      >
        <Container disableGutters>
          <Box
            sx={{
              color: "#0a3142",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: "6px",
              padding: "10px 0px"
            }}
          >
            <Stack
              onClick={shareBackHandler}
              direction="row"
              alignItems="center"
              justifyContent="center"
              className="scale-click"
            >
              <ArrowBackOutlinedIcon />
              <span>Back </span>
            </Stack>
          </Box>
          <Box>
            <Box className="share-list__body">
              {inviteArray?.map((item: any) => {
                return (
                  <div onClick={() => setStepKey(String(item?.userInfo?.shareId))} key={item?.userInfo?.shareId}>
                    <ShareItem
                      onResend={onResend}
                      roles={roles}
                      share={item?.userInfo}
                      isActive={String(item?.userInfo?.shareId) === stepKey}
                    />
                  </div>
                );
              })}
            </Box>
          </Box>
        </Container>
        {!globalDoc && (
          <>
            <Divider
              orientation="vertical"
              flexItem
              sx={{
                borderBottomWidth: "1px",
                borderColor: "#dae0e2"
              }}
            />
            {stepKey === "share" ? (
              <Stack
                alignItems="center"
                justifyContent="center"
                sx={{ minWidth: "260px", width: "100%", minHeight: "300px" }}
              >
                <Typography> Select team member from list</Typography>
              </Stack>
            ) : (
              <AccessForm />
            )}
          </>
        )}
      </Container>
      <Divider
        sx={{
          width: "100%",
          borderBottomWidth: "1px",
          borderColor: "#dae0e2"
        }}
      />
      <Stack direction="row" alignItems="center" justifyContent="flex-end" padding="7px 0px 31px 0px">
        <Button
          onClick={patchShares}
          sx={{
            color: "#ffffff",
            backgroundColor: "#173c4c",
            borderColor: "#173c4c",
            borderRadius: "21px",
            fontSize: "15px",
            padding: "8px 40px 6px 40px",
            height: "30px",
            ":hover": {
              backgroundColor: "#173c4c"
            }
          }}
          // type="submit"
          variant="contained"
        >
          Update
        </Button>
      </Stack>
    </Container>
  );
};
